import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import getMilitaryEnumDisplayName from '../getMilitaryEnumDisplayName';
import DisplayLine from './DisplayLine';
import enums from '../../../constants/enums';
import formatDate from '@unite-us/client-utils/dist/utils/dates/formatDate';
function getMilitaryData() {
  var contact = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return isEmpty(contact.military) ? {} : contact.military;
}
var getMilitaryClassname = function getMilitaryClassname() {
  var military = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var affiliation = military.affiliation || {};
  return classNames({
    hidden: affiliation !== '' && affiliation !== 'military_member_or_veteran'
  });
};
var MilitaryInformationDisplay = function MilitaryInformationDisplay(_ref) {
  var contact = _ref.contact;
  var military = getMilitaryData(contact);
  var militaryInfoClasses = getMilitaryClassname(military);
  var duration = function duration(start, end) {
    return /*#__PURE__*/React.createElement("span", null, start ? "From ".concat(formatDate(start)) : '', start && end ? " to ".concat(formatDate(end)) : '');
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "military-information-display"
  }, /*#__PURE__*/React.createElement(DisplayLine, {
    title: "Affiliation",
    value: getMilitaryEnumDisplayName(military.affiliation, enums, 'affiliation'),
    testDisplay: "affiliation-display"
  }), /*#__PURE__*/React.createElement(DisplayLine, {
    className: militaryInfoClasses,
    title: "Current Status",
    value: getMilitaryEnumDisplayName(military.current_status, enums, 'current_status'),
    testDisplay: "military-status-display"
  }), /*#__PURE__*/React.createElement(DisplayLine, {
    className: militaryInfoClasses,
    title: "Currently Transitioning?",
    value: getMilitaryEnumDisplayName(military.currently_transitioning, enums, 'transitioning'),
    testDisplay: "current-transitioning-display"
  }), /*#__PURE__*/React.createElement(DisplayLine, {
    className: militaryInfoClasses,
    title: "Branch Of Service",
    value: getMilitaryEnumDisplayName(military.branch, enums, 'branch'),
    testDisplay: "military-branch-display"
  }), /*#__PURE__*/React.createElement(DisplayLine, {
    className: militaryInfoClasses,
    title: "Service Era",
    value: getMilitaryEnumDisplayName(military.service_era, enums, 'service_era'),
    testDisplay: "military-era-display"
  }), /*#__PURE__*/React.createElement(DisplayLine, {
    className: militaryInfoClasses,
    title: "Service Dates",
    value: duration(military.entry_date, military.exit_date),
    testDisplay: "service-date-display"
  }), /*#__PURE__*/React.createElement(DisplayLine, {
    className: militaryInfoClasses,
    title: "Has at least one day of active duty outside of basic training?",
    value: getMilitaryEnumDisplayName(military.at_least_one_day_active_duty, enums, 'active_duty'),
    testDisplay: "active-duty-display"
  }), /*#__PURE__*/React.createElement(DisplayLine, {
    className: militaryInfoClasses,
    title: "Military Discharge",
    value: getMilitaryEnumDisplayName(military.discharge_type, enums, 'discharge_type'),
    testDisplay: "military-discharge-display"
  }), /*#__PURE__*/React.createElement(DisplayLine, {
    className: militaryInfoClasses,
    title: "Discharged or retired from military service for a disability incurred in the line of duty?",
    value: getMilitaryEnumDisplayName(military.discharged_due_to_disability, enums, 'discharge_disability'),
    testDisplay: "discharged-or-retired-display"
  }), /*#__PURE__*/React.createElement(DisplayLine, {
    className: militaryInfoClasses,
    title: "Has VA-rated Service-Connected Disability?",
    value: getMilitaryEnumDisplayName(military.service_connected_disability, enums, 'connected_disability'),
    testDisplay: "va-connected-disability-display"
  }), military.service_connected_disability === 'yes' && /*#__PURE__*/React.createElement(DisplayLine, {
    className: militaryInfoClasses,
    title: "Service-Connected Disability Rating",
    value: getMilitaryEnumDisplayName(military.service_connected_disability_rating, enums, 'disability_rating')
  }), /*#__PURE__*/React.createElement(DisplayLine, {
    className: militaryInfoClasses,
    title: "Has client ever been deployed?",
    value: getMilitaryEnumDisplayName(military.deployed, enums, 'deployed'),
    testDisplay: "military-deployed-display"
  }), military.deployed === 'yes' && /*#__PURE__*/React.createElement(DisplayLine, {
    className: militaryInfoClasses,
    title: "Deployment Dates",
    value: duration(military.deployment_starts_at, military.deployment_ends_at),
    testDisplay: "deployment-dates-display"
  }), /*#__PURE__*/React.createElement(DisplayLine, {
    className: militaryInfoClasses,
    title: "Proof of veteran status?",
    value: getMilitaryEnumDisplayName(military.proof_of_veteran_status, enums, 'proof_of_veteran_status'),
    testDisplay: "military-proof-display"
  }), military.proof_of_veteran_status === 'yes' && /*#__PURE__*/React.createElement(DisplayLine, {
    title: "Proof Type",
    value: getMilitaryEnumDisplayName(military.proof_type, enums, 'proof_type'),
    className: militaryInfoClasses
  }));
};
MilitaryInformationDisplay.propTypes = {
  contact: PropTypes.shape({
    military: PropTypes.object
  }).isRequired
};
export default MilitaryInformationDisplay;
//# sourceMappingURL=MilitaryInformationDisplay.js.map